import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
const DeviceTitle = () => {
    const { t } = useTranslation();
    return (_jsxs(Box, { mb: "md", children: [_jsx(Title, { order: 2, tt: "uppercase", mb: "lg", children: t('Add.Device_') }), _jsx(Divider, { size: "sm" })] }));
};
export default DeviceTitle;
